<template>
  <div class="container_four">
    <div class="chain">
      <div class="header">
        <div class="title">用电环比</div>
        <div class="tabs-container">
          <span :class="isChain == '0' ? 'active' : ''" @click="setIsChain('0')"
            >日</span
          >
          <span :class="isChain == '1' ? 'active' : ''" @click="setIsChain('1')"
            >月</span
          >
          <span :class="isChain == '2' ? 'active' : ''" @click="setIsChain('2')"
            >年</span
          >
        </div>
      </div>
      <div class="cont" >
        <div class="charts">
          <charts id="ratio" :option="ratioOption" ></charts>
          <!-- <div  class="row-center tip" v-else style="height:100%"><img :src="require('../../../assets/img/not_found_data.png')" alt=""></div> -->
        </div>
        <div class="used">
          <div class="line" v-for="(item,index) in ring" :key="index">
            <div class="totol">
              <i v-for="(elm,index2) in item.class" :key="index2">{{ elm.name }}</i>
            </div>
            <div class="parameter">
              <span>{{ item.data }}</span>
              <label >{{item.keep}}
                  <img :src="item.imgred" v-if="item.isgrow > 0" />
                  <img :src="item.imggen" v-else-if="item.isgrow==0" />
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="chain">
      <div class="header">
        <div class="title">用电同比</div>
        <!-- <div class="tabs-container">
          <span :class="isChain == '0' ? 'active' : ''" @click="setIsChain('0')"
            >日</span
          >
          <span :class="isChain == '1' ? 'active' : ''" @click="setIsChain('1')"
            >月</span
          >
          <span :class="isChain == '2' ? 'active' : ''" @click="setIsChain('2')"
            >年</span
          >
        </div> -->
      </div>
      <div class="cont" >
        <div class="charts">
          <charts id="Chain" :option="chainOption"></charts>
        </div>
        <div class="used">
          <div class="line" v-for="(item,index) in same" :key="index">
            <div class="totol">
              <i v-for="(elm,index2) in item.class" :key="index2">{{ elm.name }}</i>
            </div>
            <div class="parameter">
              <span>{{ item.data }}</span>
              <label >{{item.keep}}
                  <img :src="item.imgred" v-if="item.isgrow > 0" />
                  <img :src="item.imggen" v-else-if="item.isgrow==0" />
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import charts from "./charts.vue";

import {
    chainIndex
} from "../../api/linkindex";

export default {
  components: {
    charts,
  },
  data() {
    return {
      isChain: 1,
      isActive: 0,
      same:[],
      ring:[],
      chartRatioOption:[],
      chartChainOption:[],
    };
  },
  mounted() {},
  computed: {
    ratioOption() {
      let title = ["本月                                  上月"]
      if(this.isChain==0){
        title = ["本日                                  昨日"]
      }else if(this.isChain==1){
        title = ["本月                                  上月"]
      }else{
        title = ["本年                                  去年"]
      }
      return {
        title: {
          subtext: "用电量（kWh）",
          top: "-5%",
        },
        tooltip: {
          position: function(pt) {
            return [pt[0], "10%"];
          },
          formatter: "{a} {c} (kWh)", // 这里是鼠标移上去的显示数据
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross",
              label: {
                backgroundColor: "#6a7985",
              },
            },
          },
        },

        //ech图形pading
        grid: {
          left: "2%",
          right: "0%",
          bottom: "15%",
          top: "20%",
          containLabel: true,
        },

        legend: {
          itemWidth: 12,
          itemHeight: 12,
          x: "center",
          // data: ["本月", "上月"],
          left: "right", // 图例的位置
          textStyle: {
            color: "#999999",
          },
        },
        calculable: true,
        xAxis: [
          {
            show: true,
            name: title,
            nameLocation: "middle",
            type: "category",
          },
        ],
        // 边界值
        yAxis: [
          {
            type: "value",
            scale: true,
            min: 0,
            splitNumber: 5,
            type: "value",
          },
        ],
        series:this.chartRatioOption
      }
    },
    chainOption() {
      let  xdata = [
                "1月",
                "2月",
                "3月",
                "4月",
                "5月",
                "6月",
                "7月",
                "8月",
                "9月",
                "10月",
                "11月",
                "12月",
              ]
      return {
        title: {
          subtext: "用电量（kWh）",
          top: "-5%",
        },
        tooltip: {
          position: function(pt) {
            return [pt[0], "10%"];
          },
          formatter: "{a} {c} (kWh)", // 这里是鼠标移上去的显示数据
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross",
              label: {
                backgroundColor: "#6a7985",
              },
            },
          },
        },
        grid: {
          left: "2%",
          right: "0%",
          bottom: "0%",
          top: "20%",
          containLabel: true,
        },

        legend: {
          itemWidth: 12,
          itemHeight: 12,
          x: "center",
          // data: ["本月", "上月"],
          left: "right", // 图例的位置
          textStyle: {
            color: "#999999",
          },
        },
        calculable: true,
        xAxis: {
            type: 'category',
            data: xdata
        },
        // 边界值
        yAxis: [
          {
            type: "value",
            scale: true,
            min: 0,
            splitNumber: 5,
            type: "value",
          },
        ],
        series:this.chartChainOption
      }
    },
  },
  mounted(){
    //SEPARATED 同比  //ALTERNATE  环比
    this.chainData()
    this.sameData();
  },
  methods: {
    sameData(){
       chainIndex
        .chainData("SEPARATED", "MONTH", "PROJECT_ID", this.$store.state.project.currentProject.projectId)
        .then((res) => {
            let data1=[],data2=[]
            if (res.data.data.result) {
              res.data.data.result.forEach((item, index) => {
                  data1.push(Number(item[1]).toFixed(2));
                  data2.push(Number(item[0]).toFixed(2));
              }); 
            }
            this.chartChainOption = [{
                name:"本期",
                data:data1,
                type: 'bar',
                barWidth:15,
                itemStyle:{
                    color:'#5AD8A6',
                }
            },{
                name:"上期",
                data:data2,
                type: 'bar',
                barWidth:15,
                itemStyle:{
                    color:'#5B8FF9',
                }
            }]
        });
    
         chainIndex
        .chain("SEPARATED", "MONTH", "PROJECT_ID", this.$store.state.project.currentProject.projectId)
        .then((res) => {
            if (res.data.data.result) {
                this.$set(this.same, 0, {
                    id: 1,
                    class: [{
                            id: 1,
                            name: "本",
                        },
                        {
                            id: 2,
                            name: "期",
                        },
                        {
                            id: 3,
                            name: "用",
                        },
                        {
                            id: 4,
                            name: "电:",
                        },
                    ],
                    data: parseFloat(res.data.data.result[1].toFixed(2)),
                    keep:"kWh"
                }, );
                this.$set(this.same, 1, {
                    id: 2,
                    class: [{
                            id: 1,
                            name: "上",
                        },
                        {
                            id: 2,
                            name: "期",
                        },
                        {
                            id: 3,
                            name: "用",
                        },
                        {
                            id: 4,
                            name: "电:",
                        },
                    ],
                    data: parseFloat(res.data.data.result[0].toFixed(2)),
                    keep:"kWh"
                });
            }
            if (this.same.length) {
                if (this.same[1].data == 0 && this.same[0].data == 0) {
                    this.$set(this.same, 2, {
                        id: 3,
                        class: [{
                                id: 1,
                                name: "同",
                            },
                            {
                                id: 2,
                                name: "比",
                            },
                            {
                                id: 3,
                                name: "率:",
                            },
                        ],
                        data: 0,
                        imggen: "",
                        imgred: "",
                    });
                    // this.same[2].data = 0;
                } else {
                    this.$set(this.same, 2, {
                        id: 3,
                        class: [{
                                id: 1,
                                name: "同",
                            },
                            {
                                id: 2,
                                name: "比",
                            },
                            {
                                id: 3,
                                name: "率:",
                            },
                        ],
                        data: ((this.same[0].data - this.same[1].data) /
                                this.same[1].data) *
                            100 ==
                            " Infinity " ?
                            "100" : parseFloat(
                                (
                                    ((this.same[0].data - this.same[1].data) /
                                        this.same[1].data) *
                                    100
                                ).toFixed(2)
                            ),
                        imggen: require("../../assets/img/shang.png"),
                        imgred: require("../../assets/img/xia.png"),
                        keep:"%",
                        isgrow:0
                    });
                }

                this.$set(this.same, 3, {
                    id: 4,
                    class: [{
                            id: 1,
                            name: "累",
                        },
                        {
                            id: 2,
                            name: "计",
                        },
                        {
                            id: 3,
                            name: "同",
                        },
                        {
                            id: 4,
                            name: "比:",
                        },
                    ],
                    data: this.same[2].data,
                    imggen: require("../../assets/img/shang.png"),
                    imgred: require("../../assets/img/xia.png"),
                    keep:"%",
                    isgrow:0
                }, );
                if (this.same[2].data > 0) {
                    this.same[2].isgrow = 0;
                } else if (this.same[2].data < 0) {
                    this.same[2].isgrow = 1;
                } else {
                    this.same[2].isgrow = -1;
                }
                
                if (this.same[3].data > 0) {
                    this.same[3].isgrow = 0;
                } else if (this.same[3].data < 0) {
                    this.same[3].isgrow = 1;
                } else {
                    this.same[3].isgrow = -1;
                }
            }
        });
    },
    chainData(){
      if(this.isChain=='0'){
        this.chartRatioOption = []
        chainIndex
        .chain("ALTERNATE", "DAY", "PROJECT_ID", this.$store.state.project.currentProject.projectId)
        .then((res) => {
            if (res.data.data.result) {
                this.$set(this.ring, 0, {
                    id: 1,
                    class: [{
                            id: 1,
                            name: "本",
                        },
                        {
                            id: 2,
                            name: "日",
                        },
                        {
                            id: 3,
                            name: "用",
                        },
                        {
                            id: 4,
                            name: "电:",
                        },
                    ],
                    data: parseFloat(Number(res.data.data.result[1]).toFixed(2)),
                    keep: "kWh",
                }, );

                this.$set(this.ring, 1, {
                    id: 2,
                    class: [{
                            id: 1,
                            name: "昨",
                        },
                        {
                            id: 2,
                            name: "日",
                        },
                        {
                            id: 3,
                            name: "用",
                        },
                        {
                            id: 4,
                            name: "电:",
                        },
                    ],

                    data: parseFloat(Number(res.data.data.result[0]).toFixed(2)),
                    keep: "kWh",
                }, )
            }
            if (this.ring.length) {
                if (this.ring[0].data == 0 && this.ring[1].data == 0) {
                    // this.ring[2].data = 0;
                    this.$set(this.ring, 2, {
                        id: 3,
                        class: [{
                                id: 1,
                                name: "环",
                            },
                            {
                                id: 2,
                                name: "比",
                            },
                            {
                                id: 3,
                                name: "率:",
                            },
                        ],

                        data: 0,
                        imggen: "",
                        imgred: "",
                        keep: "%",
                    }, );
                } else {
                    this.$set(this.ring, 2, {
                        id: 3,
                        class: [{
                                id: 1,
                                name: "环",
                            },
                            {
                                id: 2,
                                name: "比",
                            },
                            {
                                id: 3,
                                name: "率:",
                            },
                        ],

                        data: ((this.ring[0].data - this.ring[1].data) / this.ring[1].data) *
                            100 ==
                            " Infinity " ?
                            "100" : parseFloat(
                                (
                                    ((this.ring[0].data - this.ring[1].data) /
                                        this.ring[1].data) *
                                    100
                                ).toFixed(2)
                            ),
                        imggen: require("../../assets/img/shang.png"),
                        imgred: require("../../assets/img/xia.png"),
                        keep: "%",
                        isgrow:0
                    }, );
                }
                this.$set(this.ring, 3, {
                    id: 4,
                    class: [{
                            id: 1,
                            name: "增",
                        },
                        {
                            id: 2,
                            name: "长",
                        },
                        {
                            id: 3,
                            name: "值:",
                        },
                    ],

                    data: (this.ring[0].data - this.ring[1].data).toFixed(2),
                    keep: "kWh",
                });
                if (this.ring[2].data > 0) {
                    this.ring[2].isgrow = 0;
                } else {
                    this.ring[2].isgrow = 1;
                }
            }
            this.chartRatioOption = [
                  {
                    name: "本日",
                    type: "bar",
                    data: [Number(res.data.data.result[1]).toFixed(2)],
                    // barGap: "10%",
                    barWidth: 132, //柱图宽度
                    itemStyle: {
                      normal: {
                        color: "#5AD8A6",
                      },
                    },
                  },
                  {
                    name: "昨日",
                    type: "bar",
                    data: [Number(res.data.data.result[0]).toFixed(2)],
                    // barleft: 200,
                    barGap: "10%",
                    barWidth: 132, //柱图宽度
                    itemStyle: {
                      normal: {
                        color: "#5B8FF9",
                      },
                    },
                  },
                ]
        });
        
      }else if(this.isChain=='1'){
        this.chartRatioOption = []
        chainIndex
        .chain("ALTERNATE", "MONTH", "PROJECT_ID", this.$store.state.project.currentProject.projectId)
        .then((res) => {
            if (res.data.data.result) {
                this.$set(this.ring, 0, {
                    id: 1,
                    class: [{
                            id: 1,
                            name: "本",
                        },
                        {
                            id: 2,
                            name: "月",
                        },
                        {
                            id: 3,
                            name: "用",
                        },
                        {
                            id: 4,
                            name: "电:",
                        },
                    ],
                    data: parseFloat(Number(res.data.data.result[1]).toFixed(2)),
                    keep: "kWh",
                }, );

                this.$set(this.ring, 1, {
                    id: 2,
                    class: [{
                            id: 1,
                            name: "上",
                        },
                        {
                            id: 2,
                            name: "月",
                        },
                        {
                            id: 3,
                            name: "用",
                        },
                        {
                            id: 4,
                            name: "电:",
                        },
                    ],

                    data: parseFloat(Number(res.data.data.result[0]).toFixed(2)),
                    keep: "kWh",
                }, )
            }
            if (this.ring.length) {
                if (this.ring[0].data == 0 && this.ring[1].data == 0) {
                    // this.ring[2].data = 0;
                    this.$set(this.ring, 2, {
                        id: 3,
                        class: [{
                                id: 1,
                                name: "环",
                            },
                            {
                                id: 2,
                                name: "比",
                            },
                            {
                                id: 3,
                                name: "率:",
                            },
                        ],

                        data: 0,
                        imggen: "",
                        imgred: "",
                        keep: "%",
                    }, );
                } else {
                    this.$set(this.ring, 2, {
                        id: 3,
                        class: [{
                                id: 1,
                                name: "环",
                            },
                            {
                                id: 2,
                                name: "比",
                            },
                            {
                                id: 3,
                                name: "率:",
                            },
                        ],

                        data: ((this.ring[0].data - this.ring[1].data) / this.ring[1].data) *
                            100 ==
                            " Infinity " ?
                            "100" : parseFloat(
                                (
                                    ((this.ring[0].data - this.ring[1].data) /
                                        this.ring[1].data) *
                                    100
                                ).toFixed(2)
                            ),
                        imggen: require("../../assets/img/shang.png"),
                        imgred: require("../../assets/img/xia.png"),
                        keep: "%",
                        isgrow:0
                    }, );
                }
                this.$set(this.ring, 3, {
                    id: 4,
                    class: [{
                            id: 1,
                            name: "增",
                        },
                        {
                            id: 2,
                            name: "长",
                        },
                        {
                            id: 3,
                            name: "值:",
                        },
                    ],

                    data: (this.ring[0].data - this.ring[1].data).toFixed(2),
                    keep: "kWh",
                });
                if (this.ring[2].data > 0) {
                    this.ring[2].isgrow = 0;
                } else {
                    this.ring[2].isgrow = 1;
                }
            }
            this.chartRatioOption = [
                  {
                    name: "本月",
                    type: "bar",
                    data: [Number(res.data.data.result[1]).toFixed(2)],
                    // barGap: "10%",
                    barWidth: 132, //柱图宽度
                    itemStyle: {
                      normal: {
                        color: "#5AD8A6",
                      },
                    },
                  },
                  {
                    name: "上月",
                    type: "bar",
                    data: [Number(res.data.data.result[0]).toFixed(2)],
                    // barleft: 200,
                    barGap: "10%",
                    barWidth: 132, //柱图宽度
                    itemStyle: {
                      normal: {
                        color: "#5B8FF9",
                      },
                    },
                  },
                ]
        });
        
       
     }else{
        this.chartRatioOption = []
        chainIndex
        .chain("ALTERNATE", "YEAR", "PROJECT_ID", this.$store.state.project.currentProject.projectId)
        .then((res) => {
            if (res.data.data.result) {
                this.$set(this.ring, 0, {
                    id: 1,
                    class: [{
                            id: 1,
                            name: "本",
                        },
                        {
                            id: 2,
                            name: "年",
                        },
                        {
                            id: 3,
                            name: "用",
                        },
                        {
                            id: 4,
                            name: "电:",
                        },
                    ],
                    data: parseFloat(Number(res.data.data.result[1]).toFixed(2)),
                    keep:"kWh"
                }, );
                this.$set(this.ring, 1, {
                    id: 2,
                    class: [{
                            id: 1,
                            name: "去",
                        },
                        {
                            id: 2,
                            name: "年",
                        },
                        {
                            id: 3,
                            name: "用",
                        },
                        {
                            id: 4,
                            name: "电:",
                        },
                    ],
                    data: parseFloat(Number(res.data.data.result[0]).toFixed(2)),
                    keep:"kWh"
                });
            }
            if (this.ring.length) {
                if (this.ring[0].data == 0 && this.ring[1].data == 0) {
                    // this.ring[2].data = 0;
                    this.$set(this.ring, 2, {
                        id: 3,
                        class: [{
                                id: 1,
                                name: "环",
                            },
                            {
                                id: 2,
                                name: "比",
                            },
                            {
                                id: 3,
                                name: "率:",
                            },
                        ],

                        data: 0,
                        imggen: "",
                        imgred: "",
                        keep: "%",
                    }, );
                } else {
                    this.$set(this.ring, 2, {
                        id: 3,
                        class: [{
                                id: 1,
                                name: "环",
                            },
                            {
                                id: 2,
                                name: "比",
                            },
                            {
                                id: 3,
                                name: "率:",
                            },
                        ],

                        data: ((this.ring[0].data - this.ring[1].data) / this.ring[1].data) *
                            100 ==
                            " Infinity " ?
                            "100" : parseFloat(
                                (
                                    ((this.ring[0].data - this.ring[1].data) /
                                        this.ring[1].data) *
                                    100
                                ).toFixed(2)
                            ),
                        imggen: require("../../assets/img/shang.png"),
                        imgred: require("../../assets/img/xia.png"),
                        keep: "%",
                        isgrow:0
                    }, );
                }
                this.$set(this.ring, 3, {
                    id: 4,
                    class: [{
                            id: 1,
                            name: "增",
                        },
                        {
                            id: 2,
                            name: "长",
                        },
                        {
                            id: 3,
                            name: "值:",
                        },
                    ],

                    data: (this.ring[0].data - this.ring[1].data).toFixed(2),
                    keep: "kWh",
                });
                if (this.ring[2].data > 0) {
                    this.ring[2].isgrow = 0;
                } else {
                    this.ring[2].isgrow = 1;
                }
            }
            this.chartRatioOption =  [
              {
                name: "本年",
                type: "bar",
                data: [Number(res.data.data.result[1]).toFixed(2)],
                // barGap: "10%",
                barWidth: 132, //柱图宽度
                itemStyle: {
                  normal: {
                    color: "#5AD8A6",
                  },
                },
              },
              {
                name: "去年",
                type: "bar",
                data: [Number(res.data.data.result[0]).toFixed(2)],
                // barleft: 200,
                barGap: "10%",
                barWidth: 132, //柱图宽度
                itemStyle: {
                  normal: {
                    color: "#5B8FF9",
                  },
                },
              },
            ]
        });
      }
    },
    setIsChain(type){
      this.isChain = type
      this.chainData()
    }
  },
};
</script>

<style scoped lang="less">
.container {
  display: flex;
  flex-wrap: wrap;
  height: 100%;
  justify-content: space-between;
  align-content: space-between;
  font-size: 18rem;
  .header {
    display: flex;
    justify-content: space-between;
    // padding-left: 24rem;
    // padding-right: 24rem;
    // height: 64rem;
    // line-height: 64rem;
    .title {
      font-size: 18rem;
      font-weight: 700;
      color: #333;
    }
    .tabs-container {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      span {
        height: 40rem;
        border-top: 2px solid #fff;
        font-size: 18rem;
        font-weight: 400;
        margin: 0 10rem;
        cursor: pointer;
        font-weight: bold;
      }
      .active {
        color: #0d94ff;
      }
    }
  }
  .container_one {
    width: 24vw;
    height: 35vh;
    background: #ffffff;
    padding: 20rem;
  }
  .container_two {
    width: 59vw;
    height: 35vh;
    background: #ffffff;
    padding: 20rem;
  }
  .container_three {
    width: 24vw;
    height: 53.5vh;
    background: #ffffff;
    padding: 20rem;
  }
  .container_four {
    width: 59vw;
    height: 53.5vh;
    justify-content: space-between;
    align-content: space-between;
    display: flex;
    flex-wrap: wrap;
  }
  .chain {
    background: #ffffff;
    padding: 20rem;
    height: 26vh;
    width: 100%;
    .cont{
      height:20vh;
      .charts{
        height:20vh;
        .w(800);
        float:left
      }
    }
  }
  .energy {
    li {
      height: 40rem;
      line-height: 40rem;
      margin-top: 8rem;
      border-bottom: 1px solid rgba(0, 0, 0, 0.15);
      font-size: 18rem;
      span {
        margin-left: 45rem;
        font-weight: bold;
        font-size: 18rem;
        img {
          vertical-align: middle;
        }
      }
    }
  }
  .monthly {
    padding-left: 20rem;
    span {
      font-size: 30rem;
      color: #0d94ff;
      i {
        font-size: 18rem;
      }
    }
  }
  .used {
    padding-top: 20rem;
    padding-left: 25rem;
    float: left;
    .w(290);
    .line {
      display: flex;
      margin-bottom: 20rem;
      align-items: center;
      &:before {
        content: "";
        width: 6rem;
        height: 6rem;
        border-radius: 50%;
        background: #666;
        vertical-align: middle;
        margin-right: 10rem;
      }
      .totol {
        font-size: 21rem;
        font-weight: 400;
        color: #666;
        width: 120rem;
        white-space: nowrap;
        display: flex;
        justify-content: space-between;
        i {
          font-style: initial;
        }
      }
      .parameter {
        font-size: 14rem;
        margin-left: 8rem;
        span {
          font-size: 20rem;
          font-weight: bold;
          margin-right: 5rem;
        }
      }
    }
  }
}
</style>
